<div
  class="component-container text-cool-grey
        flex flex-col h-[100%] justify-center items-center
        p-[4rem] xs:p-[3.2rem] min-h-full"
>
  <div class="message-container md:w-[80%] w-full">
    The consent for your participant is pending, Please contact your Administrator.
  </div>
</div>
